import type { FC } from 'react';
import type React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

import type { BusinessUnit } from 'src/types/businessUnit';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpServiceInstance from 'src/services/api/http';
import { useUserContext } from 'src/components/app/context/UserContext';

interface BusinessUnitsContextValue {
  businessUnits: BusinessUnit[];
}

export const BusinessUnitsContext = createContext<BusinessUnitsContextValue>({
  businessUnits: [],
});

interface BusinessUnitsProviderProps {
  children: React.ReactNode;
}

export const useBusinessUnits = () => useContext(BusinessUnitsContext);
export default useBusinessUnits;

export const BusinessUnitsProvider: FC<BusinessUnitsProviderProps> = ({
  children,
}) => {
  const [businessUnits, setBusinessUnits] = useState<BusinessUnit[]>([]);
  const { user } = useUserContext();

  useEffect(() => {
    if (!user) return;

    HttpServiceInstance.get(`${apiPaths.BUSINESS_UNIT}`, {})
      .then(({ data }: any) =>
        setBusinessUnits(Array.isArray(data) ? data : data?.results || []),
      )
      .catch(() => {
        console.warn('Could not get business units.');
      });
  }, [user]);

  return (
    <BusinessUnitsContext.Provider value={{ businessUnits }}>
      {children}
    </BusinessUnitsContext.Provider>
  );
};
